export const DIVISIONS_LIST = ["electricity", "gas"] as const;
export type Division = typeof DIVISIONS_LIST[number];
